module.exports = __webpack_public_path__ + "img/pdf_1.663d4dd5.png";